// hooks/useMobileDetection.js

// const isMobile = useMobileDetection(); - используем

import { useState, useEffect } from 'react';
import logger from '../utils/logger';
const useMobileDetection = () => {
  // Функция для определения мобильного устройства
  const detectMobile = () => {
    // Проверяем, что мы в браузере
    if (typeof window === 'undefined') {
      return false; // SSR поддержка
    }

    // Метод 1: Проверка User Agent
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = [
      'android', 'webos', 'iphone', 'ipad', 'ipod',
      'blackberry', 'windows phone', 'mobile'
    ];
    const isMobileUA = mobileKeywords.some(keyword =>
      userAgent.includes(keyword)
    );

    // Метод 2: Проверка touch события
    const hasTouch = 'ontouchstart' in window ||
      navigator.maxTouchPoints > 0;

    // Метод 3: Проверка ширины с учетом devicePixelRatio
    const screenWidth = window.screen.width;
    const innerWidth = window.innerWidth;
    const devicePixelRatio = window.devicePixelRatio || 1;
    const actualWidth = Math.min(screenWidth, innerWidth / devicePixelRatio);

    // Метод 4: CSS Media Query
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const isMobileCSS = mediaQuery.matches;

    // Комбинированная проверка
    return isMobileUA || (hasTouch && (actualWidth <= 768 || isMobileCSS));
  };

  // Инициализируем сразу с правильным значением
  const [isMobile, setIsMobile] = useState(() => {
    // При серверном рендеринге возвращаем false
    if (typeof window === 'undefined') {
      return false;
    }
    // При клиентском рендеринге сразу определяем устройство
    return detectMobile();
  });

  // Устанавливаем isStable сразу в true - убираем задержку!
  const [isStable, setIsStable] = useState(true);

  useEffect(() => {
    let stabilizationTimer = null;

    const checkMobile = () => {
      const newIsMobile = detectMobile();
      
      setIsMobile(prevValue => {
        if (prevValue !== newIsMobile) {
          // logger.log('Mobile detection changed:', prevValue, '->', newIsMobile);
          
          // Сбрасываем флаг стабильности при изменении
          setIsStable(false);
          
          // Устанавливаем стабильность через небольшую задержку
          if (stabilizationTimer) {
            clearTimeout(stabilizationTimer);
          }
          
          stabilizationTimer = setTimeout(() => {
            setIsStable(true);
            // logger.log('Mobile detection stabilized:', newIsMobile);
          }, 100);
          
          return newIsMobile;
        }
        return prevValue;
      });
    };

    // Убираем initialStabilizationTimer - isStable уже true

    // Слушаем изменения размера экрана
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleMediaChange = () => {
      checkMobile();
    };

    // Поддержка старых и новых браузеров
    if (mediaQuery.addListener) {
      mediaQuery.addListener(handleMediaChange);
    } else {
      mediaQuery.addEventListener('change', handleMediaChange);
    }

    // Слушаем изменения размера окна и поворот экрана
    window.addEventListener('resize', checkMobile);
    window.addEventListener('orientationchange', () => {
      setTimeout(checkMobile, 100); // Задержка для корректного определения после поворота
    });

    // Очистка слушателей
    return () => {
      if (stabilizationTimer) clearTimeout(stabilizationTimer);
      
      if (mediaQuery.removeListener) {
        mediaQuery.removeListener(handleMediaChange);
      } else {
        mediaQuery.removeEventListener('change', handleMediaChange);
      }
      
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('orientationchange', checkMobile);
    };
  }, []);
// Возвращаем объект с информацией о состоянии
  return {
    isMobile: isMobile,
    isLoading: false,
    isStable: isStable
  };
};

export default useMobileDetection;